/**
 * 推送订阅与设备时区相关工具，供 useInitApp、NotificationSection、useSubscribe 等复用。
 */

/** 设备时区相对 UTC 的偏移量（分钟），东为正、西为负，例如 +480（UTC+8）、-300（UTC-5）。服务端用于推导订阅的 _gX Topic。 */
export function getTimezoneOffsetMinutes(date: Date): number {
  return -date.getTimezoneOffset();
}

/** 推送开关状态枚举，与后端 agent_agent 订阅一致 */
export const PUSH_SUBSCRIPTION_STATUS = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
} as const;
